import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  getMetrics(id) {
    return axios.get(`${this.url}/${id}/metrics`);
  }

  exportDeliveries(id) {
    // Return the URL or make a request that triggers download.
    // For direct download, we typically just use window.location or an a tag,
    // but having the method here is good for consistency if we want to fetch as blob.
    return axios.get(`${this.url}/${id}/export`, { responseType: 'blob' });
  }

  getDashboardMetrics(params = {}) {
    return axios.get(`${this.url}/dashboard_metrics`, { params });
  }

  getLimits(inboxId) {
    return axios.get(`${this.url}/limits`, { params: { inbox_id: inboxId } });
  }

  estimate(audienceLabel) {
    return axios.get(`${this.url}/estimate`, { params: { audience_label: audienceLabel } });
  }
}

export default new CampaignsAPI();
